import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();

  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-stone-950">
        <div
          className="font-mono-mini text-xs uppercase tracking-[0.35em] text-amber-200/60"
          data-testid="auth-loading"
        >
          Lighting the candle…
        </div>
      </div>
    );
  }
  if (user === false) return <Navigate to="/auth" replace />;
  return children;
}
